module.exports = __webpack_public_path__ + "static/carpentry-6639f8d7c2712c0671a75f8a8a073f02.jpg";